import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { lightable, lighted, LightningProps } from 'owa-lightning-v2';
import { TeachingBubble } from '@fluentui/react/lib/TeachingBubble';
import loc from 'owa-localize';
import { DirectionalHint } from '@fluentui/react/lib/Callout';
import { IImageProps } from '@fluentui/react/lib/Image';
import {
    InsertLinkTeachingMomentTitle,
    InsertLinkTeachingMomentTextBegin,
    InsertLinkTeachingMomentTextEnd,
} from './InsertLinkFRECallout.locstring.json';
import { insertTooltip } from 'owa-locstrings/lib/strings/attachtooltip.locstring.json';

const styles = require('./InsertLinkFRECallout.scss');
const insertLinkImage: IImageProps = {
    src: require('./no_attachments.svg'),
};

export interface InsertLinkFRECalloutProps extends LightningProps {
    target: HTMLElement | null;
}

export const InsertLinkFRECallout = lightable(
    observer(function InsertLinkFRECallout(props: InsertLinkFRECalloutProps) {
        const { target } = props;

        const onClose = () => {
            lighted(props.lid);
        };

        return (
            <TeachingBubble
                calloutProps={{
                    beakWidth: 15,
                    directionalHint: DirectionalHint.topLeftEdge,
                    className: styles.teachingBubble,
                }}
                illustrationImage={insertLinkImage}
                target={target}
                hasCloseIcon={true}
                isWide={true}
                onDismiss={onClose}
                hasSmallHeadline={true}
                headline={loc(InsertLinkTeachingMomentTitle)}>
                {
                    <span>
                        {loc(InsertLinkTeachingMomentTextBegin)}
                        <span id="insertButtonText">{loc(insertTooltip)}</span>
                        {loc(InsertLinkTeachingMomentTextEnd)}
                    </span>
                }
            </TeachingBubble>
        );
    })
);
